
export default {
  "entityName": "patch",
  // "title": "Site request",
  "pagination": {
    "itemsPerPage": 5,
    "page": 1,
    "sortBy": "id",
    "descending": true
  },
  "fields": [
    {
      "value": "protocol_id",
      "text": "Protocol",
      title: 'name',
      "type": "autocomplete",
      validators: ['required']
    },
    {
      value: 'entity',
      type: 'hidden'
    },
    {
      value: 'entity_id',
      type: 'hidden'
    },
    {
      value: 'note',
      text: 'Note',
      full: true,
      hint: () => 'Why do you need to make a patch (note, references link)?',
      type: 'textarea',
      validators: ['required']
    }
  ],
  actions: ['upsert']
}
